module.exports = __webpack_public_path__ + "img/w3_chevron_left_dark.e87c73fb.png";